import { Component, OnInit } from '@angular/core';
import { faCog, faCogs, faFolderPlus, faCartPlus, faHighlighter, faNewspaper, faImages, faUserCog } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.less'],
    standalone: false
})
export class AdminComponent implements OnInit {

  faCog = faCog;
  faCogs = faCogs;
  faFolderPlus = faFolderPlus;
  faCartPlus = faCartPlus;
  faHighlighter = faHighlighter;
  faNewspaper = faNewspaper;
  faImages = faImages;
  faUserCog = faUserCog;

  constructor() { }

  ngOnInit() {
  }

}
